export const ModalScenes = {
  PhoneNumber: 'PhoneNumber',
  Verification: 'Verification',
};
